module.exports = {};


//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/modules/$.iterators.js
// module id = ./node_modules/core-js/library/modules/$.iterators.js
// module chunks = 2